import { getSearchURL, s3URL } from '../api';

/**
 * @param {string} searchParams
 * @returns string
 */
export const getActivityListEndpoint = searchParams => {
  const searchURL = getSearchURL();

  return new URL(`${ window.location.protocol }//${ searchURL }/api/search/buyer/activity?${ searchParams }`).toString();
};

/**
 * @param {string} searchParams
 * @returns string
 */
export const getActivityMapEndpoint = searchParams => {
  const searchURL = getSearchURL();

  return new URL(`${ window.location.protocol }//${ searchURL }/api/search/buyer/activitymap?${ searchParams }`).toString();
};

/**
 * @param {string} searchParams
 * @returns string
 */
export const getLandingPageEndpoint = searchParams => {
  const searchURL = getSearchURL();

  return new URL(`${ window.location.protocol }//${ searchURL }/api/search/buyer/box?${ searchParams }`).toString();
};

/**
 * @param {string} searchParams
 * @returns string
 */
export const getFeaturesEndpoint = () => {
  const searchURL = getSearchURL();

  return new URL(`${ window.location.protocol }//${ searchURL }/api/features`).toString();
};

/**
 * @param {string} searchParams
 * @returns string
 */
export const getLocationSuggestionsEndpoint = searchParams => {
  const searchURL = getSearchURL();

  return new URL(`${ window.location.protocol }//${ searchURL }/api/suggestion/buyer/locations?${ searchParams }`).toString();
};

/**
 * @param {string} searchParams
 * @returns string
 */
export const getSuggestionsEndpoint = (searchParams, searchByLocationEnabled) => {
  const searchURL = getSearchURL();
  const sblEndpoint = '/api/suggestion/buyer/boxes-and-location-filters';
  const normalEndpoint = '/api/suggestion/buyer/boxes-and-locations';
  const suggestionsEndpoint = searchByLocationEnabled ? sblEndpoint : normalEndpoint;

  return new URL(`${ window.location.protocol }//${ searchURL }${ suggestionsEndpoint }?${ searchParams }`).toString();
};

/**
 * @param {object} context
 * @param {string} context.brand
 * @param {string} context.locale
 * @returns string
 */
export const getOurSelectionEndpoint = ({ brand, locale }) => {
  return `${ s3URL }/our-selection/${ brand }_${ locale }.json`;
};

const popularSearchesVersion = 'v2';

/**
 * @param {object} context
 * @param {string} context.brand
 * @param {string} context.locale
 * @returns string
 */
export const getPopularSearchesEndpoint = ({ brand, locale }) => {
  return `${ s3URL }/popular-searches/${ popularSearchesVersion }_${ brand }_${ locale }.json`;
};
